import type { Achievement } from "../achievement.types";

// Awarded from word-collection progress, not from a single game report:
// see ../collectionAchievements.ts, which raises the counter to the number
// of completed seasonal collections after each game.
export const seasonalExplorerAchievement: Achievement = {
  id: "seasonalExplorer",
  name: "Seasonal Explorer",
  description: "Completed a seasonal word collection while it was in season.",
  // Counts once per collection: every word in it played while in season.
  icon: "calendar-star",
  isProgressive: true,

  check: () => false,
};
